export default __webpack_public_path__ + "static/media/logo-bp--redV2.1202e681.svg";